//import { NextSeo } from 'next-seo';
import Header from '@components/layout/header/header';
import Footer from '@components/layout/footer/footer';
import MobileNavigation from '@components/layout/mobile-navigation/mobile-navigation';
import Search from '@components/common/search';
import CookieBar from '@components/common/cookie-bar';
import { useAcceptCookies } from '@utils/use-accept-cookies';
import Button from '@components/ui-old/button';
import { useTranslation } from 'next-i18next';
export default function Layout({
  children
}: React.PropsWithChildren<{}>) {
  const {
    acceptedCookies,
    onAcceptCookies
  } = useAcceptCookies();
  const {
    t
  } = useTranslation('common');
  return <div className='flex flex-col min-h-screen' data-sentry-component="Layout" data-sentry-source-file="layout.tsx">
      {/* <NextSeo
        additionalMetaTags={[
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1.0',
          },
        ]}
        title='Forever Living Products'
        description="Forever Living has the highest quality aloe vera products and is recognized as the world's leading multi-level marketing opportunity (FBO) for 45 years!"
        canonical='https://www.flpkgz.com/'
        openGraph={{
          url: 'https://www.flpkgz.com/',
          title: 'Forever Living Products',
          description:
            "Forever Living has the highest quality aloe vera products and is recognized as the world's leading multi-level marketing opportunity (FBO) for 45 years!",
          images: [
            {
              url: '/assets/images/og-image-01.png',
              width: 800,
              height: 600,
              alt: 'Og Image Alt',
            },
            {
              url: '/assets/images/og-image-02.png',
              width: 900,
              height: 800,
              alt: 'Og Image Alt Second',
            },
          ],
        }}
       /> */}
      <Header data-sentry-element="Header" data-sentry-source-file="layout.tsx" />
      <main className='relative flex-grow' style={{
      minHeight: '-webkit-fill-available',
      WebkitOverflowScrolling: 'touch'
    }}>
        {children}
      </main>
      <Footer data-sentry-element="Footer" data-sentry-source-file="layout.tsx" />
      <MobileNavigation data-sentry-element="MobileNavigation" data-sentry-source-file="layout.tsx" />
      <Search data-sentry-element="Search" data-sentry-source-file="layout.tsx" />
      <CookieBar title={t('text-cookies-title')} hide={acceptedCookies} action={<Button onClick={() => onAcceptCookies()} variant='slim'>
            {/* @ts-ignore */}
            {t('text-accept-cookies')}
          </Button>} data-sentry-element="CookieBar" data-sentry-source-file="layout.tsx" />
    </div>;
}